import Cards from "./Cards";
export default function CardsContainer({
  accountData,
  userData,
  activeFilter,
  setIsLoading,
  isLoading,
  setModalClosed,
}) {
  return (
    <div
      className={`w-full flex-1 grid lg:grid-cols-2  justify-items-center gap-x-10 gap-y-20 pb-0.5 overflow-auto`}
    >
      {accountData &&
        accountData?.live?.length > 0 &&
        activeFilter[0] &&
        accountData.live.map((account) => {
          return (
            <Cards
              key={account.id}
              account={account}
              user={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setModalClosed={setModalClosed}
              accountType="live"
              color="blue"
            />
          );
        })}
      {accountData &&
        accountData.inactive.length > 0 &&
        activeFilter[1] &&
        accountData.inactive.map((account) => {
          return (
            <Cards
              key={account.id}
              account={account}
              user={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setModalClosed={setModalClosed}
              accountType="inactive"
              color="yellow"
            />
          );
        })}
      {accountData &&
        accountData.passed.length > 0 &&
        activeFilter[2] &&
        accountData.passed.map((account) => {
          return (
            <Cards
              key={account.id}
              account={account}
              user={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setModalClosed={setModalClosed}
              accountType="passed"
              color="green"
            />
          );
        })}
      {accountData &&
        accountData.failed.length > 0 &&
        activeFilter[3] &&
        accountData.failed.map((account) => {
          return (
            <Cards
              key={account.id}
              account={account}
              user={userData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setModalClosed={setModalClosed}
              accountType="failed"
              color="red"
            />
          );
        })}
    </div>
  );
}
